import React, { useState } from 'react'
import { useHistory, useLocation } from "react-router-dom";
import { ChevronLeft } from 'react-feather'
import { Container } from '../../../components'
import auth from '../../../utils/auth';
import { useInternationalization } from '../../../features/i18n';
import MapFilter from '../../../features/search/components/map-filter';
import Dropdown from 'react-dropdown';

const MapHeader = () => {
  const history = useHistory()
  const location = useLocation()
  const { translate, language } = useInternationalization()
  const { isOfficial, isVerified } = auth()
  const [ show, setShow ] = useState(true)

  const handleChange = ({value}) => {
    let pathname = '/organization'

    if(value === 'statistic'){
      pathname = '/organization-statistic'
    }

    history.push({
      pathname,
      search: location.search
    })
  }

  React.useEffect(() => {
    setShow(false)
    setTimeout(() => setShow(true), 100)

    //eslint-disable-next-line
  }, [language])

  return (
    <Container className={`page-header ${isOfficial ? 'official' : isVerified ? 'verified' : ''} py-5 lg:py-3 relative z-20`} color="#f5f5f5">
      <div className="flex justify-between items-center">
        <div className="flex items-center cursor-pointer">
          <ChevronLeft style={{width: '24px'}} className="mr-4"/>
          {
            show &&
            <Dropdown
              options={[
                {
                  label: translate('RELATED', 'back_to_organization_list'),
                  value: 'base',
                },
                {
                  label: translate('VIEW', 'statistic'),
                  value: 'statistic',
                },
              ]}
              onChange={handleChange}
              placeholder={translate('NAVIGATION', 'back')}
              className="map-header-dropdown"
            />
          }
        </div>
        <MapFilter />
      </div>
    </Container>
  )
}

export default MapHeader
